/*
 * @Description: 
 * @Author: 优
 * @Date: 2021-08-31 14:16:56
 * @LastEditors: weig
 * @LastEditTime: 2022-02-22 10:48:37
 */
import request from '../../utils/request'
import EnumConfig from '../../enum/EnumConfig'

var CURR_API_VERSION = EnumConfig.EnumConfig.API_VIEW_VERSION.CURR_API_VIEW_VERSION;
var API_VERSION = CURR_API_VERSION == 'V0' ? '' : `/S/${CURR_API_VERSION}`;

//获取系统资金列表
export const GetAppBalancePage=(params)=>{
    return request.apiGet(`/api${API_VERSION}/Fund/SysFund/GetAppBalancePage`,params)
}
